import styled from 'styled-components';
import { Box } from '../Box/Box';
import { Theme } from '../../../theme/theme';

interface StyledDragHandleProps {
  theme: Theme;
}

export const StyledDragHandle = styled(Box)(({ theme }: StyledDragHandleProps) => ({
  color: theme.colors.neutral['500'],
  border: 'none',
  borderRadius: theme.radii.medium,
  padding: '4px 7px',
  outline: 'none',

  '&[data-focus-visible-added]:not(.disabled):focus': {
    border: `1px solid ${theme.colors.primary['500']}`,
    boxShadow: `0px 0px 0px 2px ${theme.colors.primary['300']}`,
    zIndex: 1,
  },
}));
